// Shown when a new deploy has finished installing in the background and is
// waiting to take over (see src/serviceWorkerRegistration.js's onUpdate).
// Never reloads automatically — a visitor mid-form or mid-checkout should
// never lose that state to a silent refresh.
import React from 'react';
import './UpdateBanner.css';

const UpdateBanner = ({ registration, onDismiss }) => {
  if (!registration) return null;

  const applyUpdate = () => {
    const waiting = registration.waiting;
    if (waiting) {
      waiting.postMessage({ type: 'SKIP_WAITING' });
    }
    onDismiss();
  };

  return (
    <div className="update-banner" role="status">
      <span className="update-banner-text">A new version of the site is available.</span>
      <div className="update-banner-actions">
        <button type="button" className="update-banner-refresh" onClick={applyUpdate}>
          Refresh
        </button>
        <button
          type="button"
          className="update-banner-dismiss"
          onClick={onDismiss}
          aria-label="Dismiss update notice"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default UpdateBanner;
